<template>
  <div style="overflow: auto; height: 100%;">
    <Loading v-show="loadingNum > 0" />
    <transition name="fade-transform" mode="out-in">
      <router-view />
    </transition>
    <!-- 定位客服 -->
    <!--    <drag-side v-if="$route.path !== '/register' && $route.path !== '/QRcode' " style="display: flex;align-items: center;flex-direction: column" @click.native="toMeiQiaNoDcode" />-->
  </div>
</template>

<script>
// import DragSide from '@/components/DragSide'
import { mapState } from 'vuex'
import Loading from '@/components/loading'
// import { MeiQiaEntId, MeiQiaLoader, MeiQiaToken } from '@/utils/routeList'
// import axios from 'axios'

export default {
  name: 'App',
  components: { Loading },
  computed: {
    ...mapState(['LOADING', 'loadingNum'])
  },
  mounted() {
    /* 判断android与ios*/
    const u = navigator.userAgent
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
    this.$store.commit('setIsAndroid', isAndroid)
    this.handleWxConfig()
  },
  methods: {
    toMeiQiaNoDcode() {
      this.$api('USER_INFO_H5').then((res) => {
        console.log(res)
        const userInfoList = res.result
        const { city, province, name, phonenum, hospitalName, hospitalDepartment, hospitalPosition, hospitalAddress } = userInfoList
        // eslint-disable-next-line no-undef
        _MEIQIA('metadata', {
          '姓名': name,
          '电话号': phonenum,
          '所属医院': hospitalName,
          '医院科室': hospitalPosition,
          '所属职位': hospitalDepartment,
          '所属地址': hospitalAddress,
          '省份': province,
          '城市': city
        })
      })
      // eslint-disable-next-line no-undef
      // _MEIQIA('showPanel')
    },
    handleService() {

    },
    // 解决ios调取微信功能
    handleWxConfig() {
      this.$api('OTHER_GET_JSSDK', {
        url: window.location.href
      }).then((res) => {
        if (res.code !== 200) return
        const { result } = res
        const timestamp = result.timestamp
        const appId = result.appId
        const nonceStr = result.nonceStr
        const signature = result.signature
        // 微信授权
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: appId, // 必填，公众号的唯一标识
          timestamp: timestamp, // 必填，生成签名的时间戳
          nonceStr: nonceStr, // 必填，生成签名的随机串
          signature: signature, // 必填，签名
          jsApiList: ['stopVoice', 'startRecord', 'playVoice', 'uploadVoice', 'stopRecord', 'scanQRCode'] // 必填，需要使用的JS接口列表
        })
      })
    }
  }

}
</script>

<style lang="scss" scoped>
.text-image {
  font-size: 12px;
}
  /* 路由切换的过度动画 */
  .fade-transform-leave-active,
  .fade-transform-enter-active {
    transition: all 0.2s;
  }

  .fade-transform-enter {
    opacity: 0;
    transform: translateX(-30px);
  }

  .fade-transform-leave-to {
    opacity: 0;
    transform: translateX(30px);
  }
</style>
